<section class="marquee">
    <div class="marquee__notifications">
        <ul class="marquee__list marquee__list--scroll">
            <li class="marquee__list-item">
                {{navMarquee}}
            </li>
        </ul>
    </div>
</section>